@if (showSubscriptionModal) {
  <lib-subscription-modal
    [labels]="'lib.subscriptionModal' | translate"
    [bank]="theme"
    [step]="step"
    (close)="closeDialog()"
    [error]="registerError"
    (register)="onSignUp($event)"
    (loginAccount)="onGoToLogIn()"
    (changeStep)="onStepChange()"
  ></lib-subscription-modal>
}

@if (showSubscriptionSuccessModal) {
  <div
    class="fixed inset-0 z-[2000] w-full flex justify-center items-center bg-black/50"
    >
    <lib-modal
      [bank]="theme"
      [labels]="'lib.modal' | translate"
      [title]="'globalUi.registration.linkSentTitle' | translate"
      [text1]="'globalUi.emailSent.sentTo' | translate"
      [text2]="userEmail"
      [text3]="'globalUi.registration.toConfirm' | translate"
      [text4]="'globalUi.emailSent.notReceived' | translate"
      [buttonLabel]="'globalUi.emailSent.resend' | translate"
      (buttonClicked)="sendConfirmationEmail()"
      (closeModal)="showSubscriptionSuccessModal = false"
    ></lib-modal>
  </div>
}

<div class="relative z-[100]">
  @if (showSnackbar) {
    <lib-snackbar
      [labels]="'lib.snackbar' | translate"
      [theme]="snackbarTheme"
      [position]="'bottom'"
      [bank]="theme"
      [title]="snackbarText"
      [showIconLeft]="true"
      [showIconRight]="false"
    ></lib-snackbar>
  }
</div>
